import Button from '@/common/components/Button';
import Modal from '@/common/components/Modal';
import { useState } from 'react';
import useBlockClientCard from '../../hooks/useBlockClientCard';
import { useQueryClient } from '@tanstack/react-query';
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple';

interface BlockPersonalCardProps {
  userId?: string
  cardId?: string
}

const BlockPersonalCard = ({ userId, cardId }: BlockPersonalCardProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const queryClient = useQueryClient();

  const {
    mutate: blockClientUserCard,
    isPending: isBlockClientUserCardPending,
  } = useBlockClientCard({
    cardId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companyUser', userId] });
      setIsOpen(false);
    },
    onError: (error) => {
      setMessages(error.response?.data.errors.base || ['Occorreu um erro ao bloquear cartão.']);
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            type="button"
            variant="yellow-black"
            operationKlassToCheckPermission="Admin::Client::Cards::Block"
            name="block_card"
          >
            Bloquear cartão
          </Button>
        )}
        title="Você tem certeza?"
        subtitle="Caso o cartão do usuário seja bloqueado, nenhuma transação poderá ser feita pelo usuário."
        titleClass="text-xl"
        subtitleClassName="mt-2 !text-[16px] text-white-300"
        showClose={false}
        useCancellableFooter
        onConfirm={() => blockClientUserCard()}
        confirmButtonIsLoading={isBlockClientUserCardPending}
        disabled={isBlockClientUserCardPending}
        dataTestid="confirm_block_card"
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError
        />
      )}
    </>
  )
}

export default BlockPersonalCard;
